import { Linking } from 'react-native';

import { useDismissAllAndNavigate } from 'navigation/hooks/use-dismiss-and-navigate';
import { isExternalLink } from 'utils/is-external-link';

export const useContentCardNavigation = () => {
  const dismissAndNavigate = useDismissAllAndNavigate();

  const navigate = ({ url }: { url: string }) => {
    if (!url) {
      return;
    }

    if (isExternalLink(url)) {
      // Open absolute URLs in the default browser
      Linking.openURL(url);
    } else {
      // Navigate within the app for relative URLs
      dismissAndNavigate(url);
    }
  };

  return {
    navigate,
  };
};
